<template>
  <v-container  fluid>
    <router-view></router-view>
  </v-container>
</template>

<style scoped>
.somenziShadowns{
  z-index: 1 !important;
}
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
  export default {
    components: {
    },
    name: 'home',
    computed: {
    },
    data: () => ({
      snackbar: false,
      dialog: false,
      headers: [
        {
          text: 'Projeto',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Cliente', value: 'calories' },
        { text: 'Local', value: 'fat' },
        { text: 'Contato', value: 'carbs' },
        { text: 'Sapatas', value: 'protein' },
        { text: 'Ações', value: 'name', sortable: false }
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }),
    watch: {
  dialog (val) {
    val || this.close()
  }
},
created () {
  this.initialize()
},
methods: {
  tab_button_test () {
    console.log('OI CAUE TAB')
  },
  initialize () {
    this.items = [
      {
        name: 'Teste 1',
        calories: 'Cauê Somensi',
        fat: 'São Carlos',
        carbs: 999811155,
        protein: 8
      },
      {
        name: 'Teste 2',
        calories: 'Cauê Somensi',
        fat: 'São Carlos',
        carbs: 19999811155,
        protein: 6
      },
      {
        name: 'Teste 3',
        calories: 'Cauê Somensi',
        fat: 'São Carlos',
        carbs: 19999811155,
        protein: 3
      },
      {
        name: 'Teste 4',
        calories: 'Cauê Somensi',
        fat: 'São Carlos',
        carbs: 19999811155,
        protein: 1
      },
      {
        name: 'Teste 5',
        calories: 'Cauê Somensi',
        fat: 'São Carlos',
        carbs: 19999811155,
        protein: 2
      },
    ]
  },
}

  }
</script>



// WEBPACK FOOTER //
// src/components/home/index.vue